import { NavigatorService } from '~/support/services';

import { SET_NAVIGATOR_ENTITIES, SET_NAVIGATOR_ORGS } from './mutation-types';

export default {
  async fetchEntities({ commit }, { filters }) {
    const service = new NavigatorService(useRuntimeConfig().public.navigatorBaseUrl);
    const data = await service.fetchEntities(filters);

    commit(SET_NAVIGATOR_ENTITIES, data);
  },

  async fetchOrgs({ commit }) {
    const service = new NavigatorService(useRuntimeConfig().public.navigatorBaseUrl);
    const data = await service.fetchOrgs();

    commit(SET_NAVIGATOR_ORGS, data);
  },
};
